import { Component } from '@angular/core';
import { NavParams, AlertController, ToastController, NavController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { FacebookPage } from '../../pages/event-social/facebook/facebook';
import { TwitterPage } from '../../pages/event-social/twitter/twitter';
import { InstagramPage } from '../../pages/event-social/instagram/instagram';
import { YoutubePage } from '../../pages/event-social/youtube/youtube';

@Component({
  selector: 'event-social',
  templateUrl: 'event-social.html'
})
export class EventSocialComponent {

  obsSocial: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataSocial: any = false;

  constructor(public navCrtl: NavController, public eventProvider: EventData, public params: NavParams, public alertCtrl: AlertController, public toastCtrl: ToastController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'social').subscribe(stateModule => {
      this.closeListener(true);

      if (stateModule.$value === true) {
        this.obsSocial = this.eventProvider.getSocial(this.client, this.event.id).subscribe((data) => {
          this.dataSocial = data;

          if (data.facebookCode || data.twitterCode || data.instagramCode || data.youtubeCode) {
            this.componentState = true;
          } else {
            this.componentState = false;
          }
        });
      } else {
        this.dataSocial = false;
        this.componentState = false;
        console.log("Módulo Social deshabilitado");
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  view(social) {
    switch (social) {
      case 'facebook':
        // Generate facebookCode iframe https://developers.facebook.com/docs/plugins/page-plugin
        this.navCrtl.push(FacebookPage, {client: this.client, social: this.dataSocial, event: this.event});
      break;
      case 'twitter':
        this.navCrtl.push(TwitterPage, {client: this.client, social: this.dataSocial, event: this.event});
      break;
      case 'instagram':
        this.navCrtl.push(InstagramPage, {client: this.client, social: this.dataSocial, event: this.event});
      break;
      case 'youtube':
          this.navCrtl.push(YoutubePage, {social: this.dataSocial, event: this.event});
      break;
    }
  }

  closeListener(primaryListener = false) {
    if (this.obsListener && !primaryListener) {
      console.log('Se eliminan los observables de Social');
      this.obsListener.unsubscribe();
    }
    if (this.obsSocial) {
      this.obsSocial.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-social/event-social.ts